import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommandPaletteComponent } from './command-palette.component';

@Injectable({ providedIn: 'root' })
export class CommandPaletteService {
  private isOpen = false;

  constructor(private readonly dialog: MatDialog) {}

  open(): void {
    if (this.isOpen) {
      return;
    }

    this.isOpen = true;
    const ref = this.dialog.open(CommandPaletteComponent, {
      width: 'min(800px, calc(100vw - 32px))',
      maxWidth: '100vw',
      panelClass: 'fl-command-palette-panel',
      autoFocus: 'dialog',
      restoreFocus: true
    });

    ref.afterClosed().subscribe(() => {
      this.isOpen = false;
    });
  }
}
